import React from 'react';

const MainContent = () => {
  return (
    <main id="evento" className="main-content">
      <div className="container">
        <section className="content-section">
          <h2 className="section-title">La fiesta que une al comercio en Magangué</h2>
          <div className="text-center">
            <img 
              src="/logos/IMG_2967.JPG" 
              alt="Banner Fiesta del Tendero 2024" 
              className="event-image"
            />
            <p>
              Un evento único que celebra el espíritu emprendedor y comercial de Magangué. 
              Una oportunidad para fortalecer los lazos entre casas comerciales, mayoristas, tenderos y la comunidad.
            </p>
          </div>
        </section>

        <section className="content-section">
          <h2 className="section-title">Participa junto a tu equipo en el torneo que une al comercio de Magangué</h2>
          <div className="text-center">
            <img 
              src="/logos/Logo Torneo Fiesta del Tendero.png" 
              alt="Logo Torneo Fiesta del Tendero" 
              className="tournament-logo"
            />
            <p>
              En el marco de la Fiesta del Tendero, el comercio se une para crear un espacio de recreación, integración y deporte para el gremio que mueve la economía local.
            </p>
            <p>
              <strong>¡No te pierdas esta oportunidad de ser parte de la comunidad comercial más vibrante de Magangué!</strong>
            </p>
          </div>
        </section>

        <section id="registro" className="content-section">
          <h2 className="section-title">Registro</h2>
          <div className="text-center">
            <p className="mb-4">
              Completa tu registro para participar en la Fiesta del Tendero y ser parte de esta gran celebración del comercio local.
            </p>
            <div className="registration-info">
              <h3>¿Cómo participar?</h3>
              <ul style={{ textAlign: 'left', display: 'inline-block', maxWidth: '500px' }}>
                <li>Completa el formulario de registro</li>
                <li>Confirma tu participación</li>
                <li>Únete a las actividades del evento</li>
                <li>Disfruta de la fiesta del comercio</li>
              </ul>
            </div>
            <div className="mt-4">
              <a href="https://acsware.co/lafiestadeltenderomagangue/" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                Regístrate Aquí
              </a>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default MainContent;